import React from "react";

const Errors = ({ errors }) => {
  if (Object.keys(errors || {}).length > 0) {
    let list = [];

    for (let attr in errors) {
      errors[attr].forEach((e, i) => {
        list.push(<li key={attr + i}>{e.message}</li>);
      });
    }
    return <ul className="alert alert-danger list-unstyled form-errors">{list}</ul>;
  }
  return null;
};

export default Errors;

export const FieldWithErrors = React.forwardRef(({ errors = [], children, className = "" }, ref) => {
  return errors.length > 0 ? (
    <div ref={ref} className={`form-error ${className}`}>
      {children}
      {errors.map((e, i) => (
        <div key={e.message + i} className="form-error-message">
          {e.message}
        </div>
      ))}
    </div>
  ) : (
    <div ref={ref} className={className}>{children}</div>
  );
});
